import {
  Chip,
  CircleQuestionIcon,
  cn,
  Typography,
  TypographyColor,
} from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { T } from '../../../../Translations';

interface props {
  customClassName: string;
  src: string;
  TitleColor: TypographyColor;
  descColor: TypographyColor;
  onClick?: () => void;
  bottomSlot?: ReactNode;
}

function CollectionBuilderTile({
  customClassName,
  src,
  TitleColor,
  onClick,
  descColor,
  bottomSlot,
}: props) {
  return (
    <div className="w-1/2 items-center flex flex-col">
      <div
        className={cn(
          'py-6 px-5 border border-dashed flex-col flex items-center rounded-md',
          customClassName,
        )}
        onClick={onClick}
      >
        <div className="flex justify-end w-full">
          <CircleQuestionIcon color="gray" size="md" className="my-0.5" />
        </div>
        <img src={src} className="mb-5 w-12 h-12" />
        <Typography className="mb-2" variant="bodyMedium" fontWeight="semibold" color={TitleColor}>
          <T kind="Use the Collection Builder" />
        </Typography>
        <Typography variant="bodySmall" color={descColor} className="leading-3 self-stretch">
          <T kind="Customize all aspects of your collection..." />
        </Typography>
      </div>
      <Chip
        className="w-fit mt-4 py-1 px-3 gap-2.5 text-xs font-medium"
        color="amber"
        variant="outlined"
        radius="full"
      >
        <T kind="Invest more time" />
      </Chip>
      {bottomSlot}
    </div>
  );
}

export default observer(CollectionBuilderTile);
